export default __webpack_public_path__ + "static/media/game-catg-1.2eb19efa.jpg";